export enum REFERRAL_STATUS {
  ACTIVE = 'A',
  BLOCKED = 'B',
}
export interface ReferralParams {
  row?: number;
  fetch?: number;
  pageNo?: number;
  search?: string;
}

export interface ReferralData {
  stageTitle: string;
  createdBy: string;
  createdDate: string;
  status: REFERRAL_STATUS;
}
